"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealKosherLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealKosherLinear = function MealKosherLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.759 11l3.945-6.763a1.5 1.5 0 012.592 0L25.24 11h7.888a1.5 1.5 0 011.296 2.256L30.491 20l3.934 6.744A1.5 1.5 0 0133.13 29h-7.888l-3.945 6.764a1.5 1.5 0 01-2.592 0L14.76 29H6.87a1.5 1.5 0 01-1.295-2.256L9.509 20l-3.934-6.744A1.5 1.5 0 016.87 11h7.889zm2.315 0L20 5.985 22.925 11h-5.85zm-6.407 7.015L7.74 13h5.851l-2.925 5.015zM11.824 20l4.084-7h8.184l4.084 7-4.084 7h-8.184l-4.084-7zm-1.157 1.985L7.74 27h5.851l-2.925-5.015zM17.074 29L20 34.016 22.925 29h-5.85zm9.334-2h5.85l-2.925-5.015L26.408 27zm2.925-8.985L32.26 13h-5.851l2.925 5.015z",
    fill: "#95A0B3"
  }));
};

exports.MealKosherLinear = MealKosherLinear;
var _default = MealKosherLinear;
exports.default = _default;